<template>
  <!-- 질문12 -->
  <v-layout flex-fill column class="survey-type-03">
    <div class="subheader">최근 2주간 당신의 상태에 대한 문항입니다. </div>
    <div class="question">
      감정의 정도를 선택해 주세요.<br/>강할수록 높은 온도로 표시해 주세요.
    </div>
    <div class="answer">
      <Thermometer :emotionChoiceArr="emotionChoiceList" :emotionChoiceScoreList="emotionChoiceScoreList"
                   @emotionChoice="emotionSelected" ref="Thermometer"/>
    </div>
  </v-layout>
</template>


<script>
import store from '@/store'
import { mixinAuth } from '@/mixins'
import Thermometer from '@/components/solution/Thermometer'

export default {
  components: {
    Thermometer
  },
  mixins:[mixinAuth],
  props: ["surveyData", "travelApplStepCd", "memberStepApplCnt", "beforeSurveyData"],
  data: () => ({
    offsetTop: 0,
    model: null,
    maxSelect: 3,
    emotionChoiceList: [],
    emotionChoiceScoreList: [],
    selectArr: [],
    unitDtlReplyNo: '',
    beforeReplyNo: 0,
    choiceMap: new Map(),
    survey: [],
  }),
  // created() {
  // },
  created() {
    this.getStepLoadData()
  },
  methods: {
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.

      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data.reply != undefined && res.data.reply != null) {
              this.unitDtlReplyNo = res.data.unitDtlReplyNo
            }
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.getTravelReplyNoForUnikey()
        })
    },
    emotionSelected(emotionCd, emotionValue) {
      this.choiceMap.set(emotionCd, emotionValue);

      if (this.choiceMap.size === 3) {
        this.selectArr = [];

        for (const pos of this.choiceMap.keys()) {
          this.selectArr.push(pos + "-" + this.choiceMap.get(pos));
        }
      }

      this.$emit('emotionSelected', this.selectArr);
    },
    async getTravelThermometerChoiceList() {
      await store.dispatch('getTravelThermometerChoiceList', this.$_payload('so', [
        // {'unitDtlReplyNo':this.surveyData.unitDtlReplyNo},
        {'unitDtlReplyNo': this.unitDtlReplyNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'unitDtlBeforeReplyNo': this.beforeReplyNo},
        {'unitDtlBeforeQuesNo': this.beforeSurveyData.unitDtlQuesNo},
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitBeforeDtlNo': this.beforeSurveyData.unitDtlNo},
        {'unitNo': this.surveyData.unitNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt},
        {'memberNo': this.userKey}
      ]))
        .then(res => {
          if (res.success) {
            this.emotionChoiceList = res.data;
            this.emotionChoiceScoreList = res.data.map((item) => Number(item.value));

            this.$refs.Thermometer.methodThatForcesUpdate(this.emotionChoiceList, this.emotionChoiceScoreList);
            if (this.emotionChoiceList.length === 3) {
              this.selectArr = [];
              for (let len = 0; len < this.emotionChoiceList.length; len++) {
                this.emotionSelected(this.emotionChoiceList[len].cd, this.emotionChoiceList[len].value)
              }
            }
          } else {
            console.log(res.msg)
            this.emotionChoiceList = [];
            this.emotionChoiceScoreList = [];
          }
        })
        .catch(error => {
          console.error(error)
          this.emotionChoiceList = [];
          this.emotionChoiceScoreList = [];
        })
        .finally(() => {
        })
    },
    async getTravelReplyNoForUnikey() {
      await store.dispatch('getTravelReplyNoForUnikey', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitDtlQuesNo': this.beforeSurveyData.unitDtlQuesNo},
        {'unitDtlNo': this.beforeSurveyData.unitDtlNo},
        {'unitNo': this.surveyData.unitNo}
      ]))
        .then(res => {
          if (res.success) {
            this.beforeReplyNo = res.data;

            setTimeout(() => this.getTravelThermometerChoiceList(), 300);
          } else {
            console.log(res.msg)
            this.beforeReplyNo = 0;
          }
        })
        .catch(error => {
          console.error(error)
          this.beforeReplyNo = 0;
        })
        .finally(() => {
        })
    }
  }
}
</script>
